import { WithAccountId } from '@mews-commander/types';
import { useLocalizeText } from '@mews/framework';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { createCardLabel } from '@mews-commander/legacy-entities/src/ducks/paymentCards';

export const useGetPaymentMethodsForSelectSuspense = ({ accountId }: WithAccountId) => {
    const localizeText = useLocalizeText();

    return useRepositorySuspenseQuery(
        'accountPaymentMethods',
        'getAll',
        { accountId },
        {
            select: ({ paymentCards, sepas }) => {
                const cardsPaymentMethods =
                    paymentCards?.map((paymentCard) => ({
                        ...paymentCard,
                        title: createCardLabel(paymentCard),
                    })) ?? [];
                const sepaPaymentMethods =
                    sepas?.map((sepa) => ({
                        ...sepa,
                        title: `${localizeText({ textKey: TextKey.Sepa })} ${sepa.lastDigits}`,
                    })) ?? [];

                return { paymentCards: cardsPaymentMethods, sepas: sepaPaymentMethods };
            },
        }
    );
};
